import React from 'react';
import { Label } from '@atlaskit/form';
import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';

import { RedirectType } from '../../../../../../../types';

import { BoldEmailWrapper, VerifiedEmailWrapper, VerifiedIconWrapper } from './styled';
import messages from './EmailVerified.messages';
import { FormattedMessage } from 'react-intl';

export const EmailVerified = ({
  email,
  iconLabel,
  redirectType,
}: {
  email: string;
  iconLabel: string;
  redirectType: string;
}) => {
  return (
    <VerifiedEmailWrapper>
      <Label htmlFor="email-verified">
        <FormattedMessage {...messages.emailAddressLabel} />
        {redirectType !== RedirectType.Signup && redirectType !== RedirectType.ResumeSignup && (
          <VerifiedIconWrapper>
            <CheckCircleIcon label={iconLabel} size="small" />
          </VerifiedIconWrapper>
        )}
      </Label>
      <BoldEmailWrapper id="email-verified">{email}</BoldEmailWrapper>
    </VerifiedEmailWrapper>
  );
};
